import React from "react";
import { Button } from "@/components/ui/button";
import { usePrivy } from "@privy-io/react-auth";

interface MintTokenWalletProps extends React.HTMLAttributes<HTMLDivElement> {
  authenticated: boolean;
  wallets: { address?: string }[] | undefined;
  login: () => void;
}

const MintTokenWallet: React.FC<MintTokenWalletProps> = ({
  authenticated,
  wallets,
  login,
  ...props
}) => {
  const { connectWallet } = usePrivy();

  return (
    <div {...props}>
      {authenticated ? (
        <div className="text-sm mb-4">
          {wallets && wallets.length > 0 ? (
            <div className="flex flex-col sm:flex-row gap-2 items-baseline">
              <Button
                onClick={() =>
                  connectWallet({ walletList: ["detected_solana_wallets"] })
                }
                variant="outline"
                size="sm"
              >
                Change Wallet
              </Button>
              <div className="text-green-500 mb-2">
                <span className="break-all">
                  Connected Wallet: {wallets[0].address}
                </span>
              </div>
            </div>
          ) : (
            <div className="flex flex-col gap-2">
              <Button
                onClick={() =>
                  connectWallet({ walletList: ["detected_solana_wallets"] })
                }
              >
                Connect Solana Wallet
              </Button>
              <div className="text-red-500 mb-2">
                No Solana wallet connected.
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="mb-4">
          <Button onClick={login} variant="outline" className="w-full">
            Connect Wallet
          </Button>
        </div>
      )}
    </div>
  );
};

export default MintTokenWallet;
